import type { ICarousel } from "@/components/Carousel/Carousel.model"
import type { IPostCodeFormModel } from "./PostCodeForm/PostCodeForm.model"
import type { InjectionKey, Ref } from "vue"
import type { IHospice } from "@/api/registerTree"
import type { RegistrationSoonFormModel } from "./RegistrationSoonForm/RegistrationSoonForm.model"
import type { IRegistrationCloseFormModel } from "./RegistrationCloseForm/RegistrationCloseForm.model"
import type { IRegistrationOpenFormModel } from "./RegistrationOpenForm/RegistrationOpenForm.model"

export interface ITreeRegistrationProps {
  model: {
    postCodeDto: IPostCodeFormModel
    noCollectionDto: IRegistrationCloseFormModel
    openCollectionDto: IRegistrationOpenFormModel
    carousel?: ICarousel
    registrationSoon: RegistrationSoonFormModel
  }
}

export const enum CollectionLookup {
  NONE = 0,
  REGISTRATION_CLOSED = 1,
  REGISTRATION_OPEN = 2,
  REGISTRATION_FULL = 3,
  REGISTRATION_SOON = 4,
}

export interface IPostCodeData {
  collectionLookupResult: Ref<CollectionLookup>
  hospices: Ref<IHospice[] | null>
  postCode: Ref<string>
}

export const PostCodeDataKey: InjectionKey<IPostCodeData> = Symbol("postCodeData")
